// extracted by mini-css-extract-plugin
export var intro = "blog-module--intro--nlMin";
export var pageContent = "blog-module--page-content--n3t2a";
export var sectionSpacingB = "blog-module--section-spacing-b--X0yPy";
export var sectionSpacingT = "blog-module--section-spacing-t--F0HFp";